export default "__VITE_ASSET__BJUqtFtL__"